// src/components/FridgeArea.js
import React from 'react'
import { useDrop } from 'react-dnd';
import { ItemTypes } from '../constants/ItemTypes';
import StickyNote from './StickyNote';

function FridgeArea({ items, onMove }) {
  const [{ isOver, canDrop }, drop] = useDrop(() => ({
    accept: ItemTypes.STICKY_NOTE,
    drop: () => ({ areaType: 'fridge' }), // ドロップされたことを示す
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  }));

  const isActive = isOver && canDrop;
  let backgroundColor = '#e0ffe0'; // 冷蔵庫エリアのデフォルト色
  if (isActive) {
    backgroundColor = '#aaffaa'; // ドロップ可能なときの強調色
  } else if (canDrop) {
    backgroundColor = '#c0ffc0'; // ドロップ中の強調色
  }

  const areaStyle = {
    width: '90%',
    minHeight: '200px',
    border: '2px dashed #66bb6a',
    borderRadius: '10px',
    backgroundColor: backgroundColor,
    padding: '15px',
    margin: '20px auto',
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    boxSizing: 'border-box',
  };

  return (
    <div ref={drop} style={areaStyle}>
      <h3>冷蔵庫の中身</h3>
      {items.length === 0 ? (
        <p style={{ color: '#666' }}>ここに付箋をドラッグしてください</p>
      ) : (
        items.map((item) => (
          <StickyNote
            key={item.id}
            id={item.id}
            name={item.name}
            type={item.type}
            onMove={onMove}
          />
        ))
      )}
    </div>
  );
}

export default FridgeArea;